import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Tutor } from '../model/Tutor.model';
import { TutorDisponibilidad } from '../model/TutorDisponibilidad';
import { StorageService } from './storage.service';



const guardarTutorDisponibilidad = 'tutor/saveTutorDisponibilidad';
const getTutorByIdUsuario = 'tutor/getTutorByIdUsuario/';
const getTutorObjectByIdUsuario = 'tutor/getTutorObjectByIdUsuario/';
const getTutorDisponibilidadByIdUsuario = 'tutor/getTutorDisponibilidadByIdUsuario/';
const deleteTutorDisponibilidad = 'tutor/deleteTutorDisponibilidad/';
const getMisUnidadesEducativas = 'tutor/getMisUnidadesEducativas/';
const crearConsultaTutor = 'tutor/crearConsultaTutor/';
const getTutoresMegatutor = 'megatutor/getTutorByIdMegatutor/';
const getEncuestaTutoria = 'megatutor/getEncuestaTutoria/';


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'Basic ' + btoa('croamora:cristianroa.123')
  })
};  
const httpOptionsFile = {

  headers: new HttpHeaders({    
    'Authorization': 'Basic ' + btoa('croamora:cristianroa.123')
  })
}; 
@Injectable({
  providedIn: 'root'
})
export class TutorService {
  

  constructor(private http:HttpClient,private storageService: StorageService) { }


  public tutor = new Tutor(); 


  API_POST_getIdTutorByIdUsuario(idUsuario: number) {
    return this.http.post(environment.apiEndpoint + getTutorByIdUsuario + idUsuario , null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }
  
  API_POST_getTutorObjectByIdUsuario(idUsuario: number) {
    return this.http.post(environment.apiEndpoint + getTutorObjectByIdUsuario + idUsuario , null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }
  
  API_POST_guardarTutorDisponibilidad(tutorDisponibilidad: TutorDisponibilidad) {
    return this.http.post(environment.apiEndpoint + guardarTutorDisponibilidad , tutorDisponibilidad, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_getTutorDisponibilidadByIdUsuario(idUsuario: number) {
    return this.http.post(environment.apiEndpoint + getTutorDisponibilidadByIdUsuario + idUsuario , null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_DELETE_deleteTutorDisponibilidad(idTutorDisponibilidad: number) {
    return this.http.post(environment.apiEndpoint + deleteTutorDisponibilidad + idTutorDisponibilidad ,null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_getMisUnidadesEducativas(idTutorPersonaPeriodo: number) {
    return this.http.post(environment.apiEndpoint + getMisUnidadesEducativas + idTutorPersonaPeriodo , null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_crearConsultaTutor(json): Observable<any>{    
              
    return this.http.post(environment.apiEndpoint + crearConsultaTutor , json, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_obtenerMisConsultasTutor(idTutor : number): Observable<any>{    
      
    return this.http.post(environment.apiEndpoint + "tutor/" + idTutor + "/getMisConsultas"  , null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_obtenerTutoresMegatutor(idTutor:number): Observable<any>{    
    return this.http.post(environment.apiEndpoint + getTutoresMegatutor + idTutor, null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_obtenerEncuestaTutoria(idJardinPeriodoTutoria:number): Observable<any>{    
    return this.http.post(environment.apiEndpoint + getEncuestaTutoria + idJardinPeriodoTutoria, null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  handleError(error) {    
    let errorMessage = '';
    errorMessage = `Error Code: ${error.status}\nMessage: ${error.error.message}`;
    return throwError(errorMessage);
  }

}
